module.exports = __webpack_public_path__ + "img/werner-main-logo.10e76dc3.svg";